import React, { Fragment } from "react";
import { Button, CardHeader } from "reactstrap";

import { H2, P } from "../../../AbstractElements";
import { CommonCardHeaderProps } from "./TabCountries";

export default function CommonCardHeader({
  headClass,
  title,
  subTitle,
  titleClass,
 
}: CommonCardHeaderProps) {


  return (
    <CardHeader className={`${headClass} countries__flag_header`}>
      <div>
        <H2 className={`mb-0 ${titleClass ? titleClass : ""}`}>{title}</H2>
        <P className="f-m-light mt-2">{subTitle}</P>
      </div>
     
    </CardHeader>
  );
}
